function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.43359,
  y: 4.56982,
  width: 20,
  height: 2,
  rx: 1,
  transform: "rotate(37.744 4.43359 4.56982)",
  fill: "#2664DF"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3302 10.4761C15.3322 10.4287 15.3332 10.3812 15.3332 10.3333C15.3332 8.49239 13.8408 7 11.9999 7C11.6612 7 11.3343 7.05051 11.0264 7.1444L15.3302 10.4761Z",
  fill: "#2664DF"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.79968 9.1377C2.66543 9.94856 2 10.9354 2 12C2 14.7615 6.47716 17.0001 12 17.0001C12.6308 17.0001 13.248 16.9708 13.8464 16.915L11.7981 15.3294C9.62825 15.2432 7.814 13.7742 7.21232 11.7795L3.79968 9.1377ZM16.8287 11.6359L20.5986 14.5543C21.4887 13.8067 22 12.9332 22 12C22 9.96381 19.5657 8.21187 16.0727 7.43213C16.6565 8.25024 17 9.25169 17 10.3334C17 10.784 16.9404 11.2206 16.8287 11.6359Z",
  fill: "#2664DF"
});
function SvgCloseEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEyes);
export default __webpack_public_path__ + "static/media/close-eyes.36362dc8.svg";
export { ForwardRef as ReactComponent };